module.exports = __webpack_public_path__ + "static/lightning-table-selected-rows-2d0f7e9b7092f034e68f3c75f945fbdd.png";